import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/x-dots.svg'


const _withScopeId = n => (_pushScopeId("data-v-68a223d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%","height":"100%","object-fit":"cover","position":"absolute"},
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "login-box" }
const _hoisted_4 = { class: "sign-in-text" }
const _hoisted_5 = { style: {"display":"flex","align-items":"flex-start","width":"100%","gap":"45px"} }
const _hoisted_6 = { class: "login-field" }
const _hoisted_7 = { class: "login-field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "login-actions" }
const _hoisted_12 = { class: "login-btn" }
const _hoisted_13 = { style: {"height":"50px"} }
const _hoisted_14 = {
  key: 0,
  class: "login-error animated-fast"
}
const _hoisted_15 = {
  key: 0,
  style: {"text-align":"left","display":"block"},
  class: "login-success animated-fast"
}
const _hoisted_16 = { class: "reset-suggestions" }
const _hoisted_17 = { class: "reset-suggestion" }
const _hoisted_18 = {
  key: 0,
  class: "fa fa-times animated-fast"
}
const _hoisted_19 = {
  key: 1,
  class: "fa fa-check animated-fast"
}
const _hoisted_20 = { class: "reset-suggestion" }
const _hoisted_21 = {
  key: 0,
  class: "fa fa-times animated-fast"
}
const _hoisted_22 = {
  key: 1,
  class: "fa fa-check animated-fast"
}
const _hoisted_23 = { class: "reset-suggestion" }
const _hoisted_24 = {
  key: 0,
  class: "fa fa-times animated-fast"
}
const _hoisted_25 = {
  key: 1,
  class: "fa fa-check animated-fast"
}
const _hoisted_26 = { class: "reset-suggestion" }
const _hoisted_27 = {
  key: 0,
  class: "fa fa-times animated-fast"
}
const _hoisted_28 = {
  key: 1,
  class: "fa fa-check animated-fast"
}
const _hoisted_29 = { class: "reset-suggestion" }
const _hoisted_30 = {
  key: 0,
  class: "fa fa-times animated-fast"
}
const _hoisted_31 = {
  key: 1,
  class: "fa fa-check animated-fast"
}
const _hoisted_32 = { class: "reset-suggestion" }
const _hoisted_33 = {
  key: 0,
  class: "fa fa-times animated-fast"
}
const _hoisted_34 = {
  key: 1,
  class: "fa fa-check animated-fast"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.newUser ? _ctx.$t(`resetPassword.create`) : _ctx.$t(`resetPassword.reset`)) + " " + _toDisplayString(_ctx.$t(`resetPassword.password`)), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          class: "login-form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (
						_ctx.hasNumber &&
						_ctx.hasUppercase &&
						_ctx.longerThan8 &&
						_ctx.passwordMatch &&
						_ctx.hasSpecialCharacter &&
						_ctx.hasLowercase
							? _ctx.submitForgotPassword()
							: null
					), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_imdex_text_field, {
              error: _ctx.passwordError,
              label: _ctx.$t(`resetPassword.password`),
              type: _ctx.showPassword ? 'text' : 'password',
              value: _ctx.password,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
              leadingIcon: "fa fa-lock"
            }, null, 8, ["error", "label", "type", "value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_imdex_text_field, {
              error: _ctx.passwordError,
              label: _ctx.$t(`resetPassword.retypePassword`),
              type: _ctx.showPassword ? 'text' : 'password',
              value: _ctx.retypePassword,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.retypePassword) = $event)),
              leadingIcon: "fa fa-lock"
            }, null, 8, ["error", "label", "type", "value"]),
            _hoisted_8,
            _createElementVNode("div", {
              class: "show-password-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword)),
              text: "",
              compact: ""
            }, [
              (!_ctx.showPassword)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t(`resetPassword.show`)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t(`resetPassword.hide`)), 1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t(`resetPassword.password`)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (!_ctx.success)
                ? (_openBlock(), _createBlock(_component_imdex_btn, {
                    key: 0,
                    disabled: 
									!_ctx.hasNumber ||
									!_ctx.hasUppercase ||
									!_ctx.longerThan8 ||
									!_ctx.passwordMatch ||
									!_ctx.hasSpecialCharacter ||
									!_ctx.hasLowercase
								,
                    type: "submit",
                    loading: _ctx.isLoading,
                    secondary: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.newUser ? _ctx.$t(`resetPassword.create`) : _ctx.$t(`resetPassword.reset`)) + " " + _toDisplayString(_ctx.$t(`resetPassword.password`)), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"]))
                : _createCommentVNode("", true),
              (_ctx.success)
                ? (_openBlock(), _createBlock(_component_imdex_btn, {
                    key: 1,
                    type: "submit",
                    loading: _ctx.isLoading,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/'))),
                    secondary: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`resetPassword.backToLogin`)), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_Transition, {
                "enter-active-class": "fadeInUp",
                "leave-active-class": "fadeOutDown"
              }, {
                default: _withCtx(() => [
                  (_ctx.errorMessage != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, {
                "enter-active-class": "fadeInUp",
                "leave-active-class": "fadeOutDown"
              }, {
                default: _withCtx(() => [
                  (_ctx.success)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t(`resetPassword.success`)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ])
        ], 32),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t(`resetPassword.passMustInclude`)), 1),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "fadeInUp",
              "leave-active-class": "fadeOutDown"
            }, {
              default: _withCtx(() => [
                (!_ctx.longerThan8)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                  : (_openBlock(), _createElementBlock("i", _hoisted_19))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`resetPassword.8pluschars`)), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "fadeInUp",
              "leave-active-class": "fadeOutDown"
            }, {
              default: _withCtx(() => [
                (!_ctx.hasUppercase)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                  : (_openBlock(), _createElementBlock("i", _hoisted_22))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`resetPassword.upperCase`)), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "fadeInUp",
              "leave-active-class": "fadeOutDown"
            }, {
              default: _withCtx(() => [
                (!_ctx.hasLowercase)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                  : (_openBlock(), _createElementBlock("i", _hoisted_25))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`resetPassword.lowerCase`)), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "fadeInUp",
              "leave-active-class": "fadeOutDown"
            }, {
              default: _withCtx(() => [
                (!_ctx.hasNumber)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                  : (_openBlock(), _createElementBlock("i", _hoisted_28))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`resetPassword.number`)), 1)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "fadeInUp",
              "leave-active-class": "fadeOutDown"
            }, {
              default: _withCtx(() => [
                (!_ctx.hasSpecialCharacter)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_30))
                  : (_openBlock(), _createElementBlock("i", _hoisted_31))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`resetPassword.specialChar`)), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "fadeInUp",
              "leave-active-class": "fadeOutDown"
            }, {
              default: _withCtx(() => [
                (!_ctx.passwordMatch)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                  : (_openBlock(), _createElementBlock("i", _hoisted_34))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`resetPassword.passwordsMatch`)), 1)
          ])
        ])
      ])
    ])
  ]))
}